/* eslint-disable */

import _ from 'lodash'

export function getRfqs(state) {
  return state.rfqs.items;
}

export function getSearchIndexById(state) {
  return state.searchIndexById
}

export function getActiveCustomers(state) {
  return state.activeSorted
}

export function getCancelledCustomers(state) {
  return state.cancelledSorted
}

export function getCustomers(state) {
  return state.fullSorted
}

export function getPerPage(state) {
  return state.perPage;
}

export function getFilter(state) {
  return state.filter;
}

export function getCustomersAllCurrentPage(state) {
  return state.customersAllCurrentPage;
}

export function getCustomersPreferedCurrentPage(state) {
  return state.customersPreferedCurrentPage;
}
